"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgileTrialWarningCard = void 0;
const commands_1 = require("../../_shared/commands");
const components_1 = require("../../_shared/components");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const TITLE = "Your trial of AgilePolly is coming to an end";
const MESSAGE = "Please upgrade to a paid subscription to continue using standup features";
const AgileTrialWarningCard = (webDomain) => {
    const card = CardHelper_1.CardHelper.newCard();
    card.addItem((0, components_1.SubscribeBlock)("agile", TITLE, MESSAGE, webDomain, "agile-trial-warning-dm"));
    card.addAction((0, commands_1.DeleteCardAction)());
    return card;
};
exports.AgileTrialWarningCard = AgileTrialWarningCard;
//# sourceMappingURL=AgileTrialWarningCard.js.map